// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"a216ead1","233":"a1f4f6f6","427":"35aeaf1c"}[chunkId] + ".chunk.js";
};